export function useAutoTrading() {
  return { enabled: false, toggle: () => {} };
}
